import { Service } from '@genial/services';

import { screenName } from '../../../store/batchTicket/constants';
import { PatchCustomerTagService } from '../utils/types';

export const getAllTags = async (advisorId?: number) => {
  const { data, statusCode, meta } = await Service.Customer.V1.getAllTag({
    screenName,
    advisorId,
  });

  if (statusCode === 200) {
    return { data, meta, statusCode };
  }

  throw new Error('Não foi possível processar a requisição.');
};

export const patchCustomerTagService = async ({
  customerId,
  tagCustomerItem,
}: PatchCustomerTagService) => {
  const { data, statusCode } = await Service.Customer.V1.patchTagByUpsertTagCustomerId({
    screenName,
    customerId,
    customerTagUpsertRequest: {
      tagId: tagCustomerItem.tagId,
      tagName: tagCustomerItem.tagName,
    },
  });

  if (statusCode === 200) {
    return data;
  }

  throw new Error('Não foi possível processar a requisição.');
};

export const patchDeleteTagService = async (tagId: string) => {
  const { data, statusCode } = await Service.Customer.V1.patchTag({
    screenName,
    tagId,
  });

  if (statusCode === 200) {
    return data;
  }

  throw new Error('Não foi possível processar a requisição.');
};

export const deleteRelateCustomerTag = async (tagId: string, customerId: number) => {
  const { data, statusCode } = await Service.Customer.V1.deleteTag({
    screenName,
    tagId,
    customerId,
  });

  if (statusCode === 200) {
    return data;
  }

  throw new Error('Não foi possível processar a requisição.');
};
